import { render, staticRenderFns } from "./ExtractionTemplateListItem.vue?vue&type=template&id=6306abee&scoped=true&"
import script from "./ExtractionTemplateListItem.vue?vue&type=script&lang=js&"
export * from "./ExtractionTemplateListItem.vue?vue&type=script&lang=js&"
import style0 from "./ExtractionTemplateListItem.vue?vue&type=style&index=0&id=6306abee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6306abee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
